import { AxiosResponse } from "axios"
import ConnectApi from "../baseService"
import { TApiResponse } from "../TApiResponse"
import {
  TTorikomiFileGetListReq,
  TTorikomiFileGetListRes,
  TTorikomiFilePostReq,
} from "./TTorikomiFile"

/**
 * 取込ファイルに対するAPIリクエスト用サービス
 *
 * @export
 * @class TorikomiFileService
 * @extends {ConnectApi}
 */
export default class TorikomiFileService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TTorikomiFileGetListReq} params
   * @memberof TorikomiFileService
   */
  getList = async (params: TTorikomiFileGetListReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTorikomiFileGetListRes[]>> =
        await this.getInner(`/torikomifiles`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TTorikomiFilePostReq} data
   * @param {(param: TApiResponse<boolean>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<boolean>>) => any} reject
   * @memberof KyotenService
   */
  post = async (data: TTorikomiFilePostReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> =
        await this.postFormDataInner(`/torikomifiles`, data, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
